import type { ElementProps } from "../types";
import S from "./EmailNotificationHeader.module.scss";

export const EmailNotificationHeader = ({ template, innerRef }: ElementProps) => {
  return (
    <div className={S.headerInfo}>
      <h1
        className="atlas-h3 text-center"
        contentEditable
        ref={(innerRef as React.RefObject<HTMLHeadingElement>) ?? undefined}
        dangerouslySetInnerHTML={{ __html: template.text }}
      />
    </div>
  );
};
